(function () {
  var activeControllers = new WeakMap();

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function formatMoney(priceString) {
    var amount = parseFloat(priceString);
    if (isNaN(amount)) return '';
    // Simple USD-style formatting. If this store sells in multiple currencies,
    // swap this for Shopify.formatMoney(amount * 100, Shopify.money_format) instead.
    return '$' + amount.toFixed(2);
  }

  function buildResultsHtml(data, term, searchUrl) {
    var results = (data && data.resources && data.resources.results) || {};
    var products = results.products || [];
    var collections = results.collections || [];
    var pages = results.pages || [];

    var hasResults = products.length > 0 || collections.length > 0 || pages.length > 0;

    if (!hasResults) {
      return '<p class="predictive-search-results__empty">No results for &ldquo;' + escapeHtml(term) + '&rdquo;.</p>';
    }

    var html = '<div class="predictive-search-results__wrapper">';

    if (products.length > 0) {
      html += '<div class="predictive-search-results__group">';
      html += '<h3 class="predictive-search-results__heading">Products</h3>';
      html += '<ul class="predictive-search-results__list" role="list">';
      products.forEach(function (product) {
        var imageUrl = product.image || (product.featured_image && product.featured_image.url) || '';
        var priceHtml = (product.price_min && product.price_min !== product.price_max)
          ? 'From ' + formatMoney(product.price_min)
          : formatMoney(product.price);
        html += '<li class="predictive-search-results__item">';
        html += '<a href="' + escapeHtml(product.url) + '" class="predictive-search-results__link">';
        if (imageUrl) {
          html += '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="50" height="50">';
        }
        html += '<span class="predictive-search-results__item-info">';
        html += '<span class="predictive-search-results__item-title">' + escapeHtml(product.title) + '</span>';
        html += '<span class="predictive-search-results__item-price">' + priceHtml + '</span>';
        html += '</span></a></li>';
      });
      html += '</ul></div>';
    }

    if (collections.length > 0) {
      html += '<div class="predictive-search-results__group">';
      html += '<h3 class="predictive-search-results__heading">Collections</h3>';
      html += '<ul class="predictive-search-results__list" role="list">';
      collections.forEach(function (collection) {
        html += '<li class="predictive-search-results__item">';
        html += '<a href="' + escapeHtml(collection.url) + '" class="predictive-search-results__link predictive-search-results__link--text-only">' + escapeHtml(collection.title) + '</a>';
        html += '</li>';
      });
      html += '</ul></div>';
    }

    if (pages.length > 0) {
      html += '<div class="predictive-search-results__group">';
      html += '<h3 class="predictive-search-results__heading">Pages</h3>';
      html += '<ul class="predictive-search-results__list" role="list">';
      pages.forEach(function (page) {
        html += '<li class="predictive-search-results__item">';
        html += '<a href="' + escapeHtml(page.url) + '" class="predictive-search-results__link predictive-search-results__link--text-only">' + escapeHtml(page.title) + '</a>';
        html += '</li>';
      });
      html += '</ul></div>';
    }

    html += '<a href="' + searchUrl + '?q=' + encodeURIComponent(term) + '" class="predictive-search-results__view-all">View all results for &ldquo;' + escapeHtml(term) + '&rdquo;</a>';
    html += '</div>';

    return html;
  }

  function search(wrapper, term) {
    var baseUrl = wrapper.getAttribute('data-url');
    var searchUrl = wrapper.getAttribute('data-search-url');
    var resultsEl = wrapper.querySelector('[data-predictive-search-results]');
    var input = wrapper.querySelector('[data-predictive-search-input]');
    if (!baseUrl) return;

    if (term.length < 2) {
      if (resultsEl) {
        resultsEl.innerHTML = '';
        resultsEl.hidden = true;
      }
      if (input) input.setAttribute('aria-expanded', 'false');
      return;
    }

    var previousController = activeControllers.get(wrapper);
    if (previousController) previousController.abort();

    var controller = new AbortController();
    activeControllers.set(wrapper, controller);

    var url = baseUrl + '.json'
      + '?q=' + encodeURIComponent(term)
      + '&resources[type]=product,collection,page'
      + '&resources[limit]=4';

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search request failed with status ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        if (!resultsEl) return;
        resultsEl.innerHTML = buildResultsHtml(data, term, searchUrl);
        resultsEl.hidden = false;
        if (input) input.setAttribute('aria-expanded', 'true');
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('[predictive-search]', error, 'URL was:', url);
          if (resultsEl) {
            resultsEl.hidden = false;
            resultsEl.innerHTML = '<p class="predictive-search-results__empty">Search error - check the browser console for details.</p>';
          }
        }
      });
  }

  function initPredictiveSearchInputs() {
    var wrappers = document.querySelectorAll('[data-predictive-search]');

    wrappers.forEach(function (wrapper) {
      var input = wrapper.querySelector('[data-predictive-search-input]');
      var form = wrapper.querySelector('[data-predictive-search-form]');
      if (!input) return;

      var debouncedSearch = debounce(function () {
        search(wrapper, input.value.trim());
      }, 300);

      input.addEventListener('input', debouncedSearch);

      if (form) {
        form.addEventListener('submit', function (event) {
          if (input.value.trim().length === 0) {
            event.preventDefault();
          }
        });
      }
    });
  }

  function initSearchModal() {
    var toggle = document.getElementById('searchToggle');
    var modal = document.getElementById('searchModal');
    var backdrop = document.getElementById('searchModalBackdrop');
    var closeBtn = document.getElementById('searchModalClose');
    if (!toggle || !modal) return;

    function openModal() {
      modal.hidden = false;
      if (backdrop) backdrop.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      var input = modal.querySelector('[data-predictive-search-input]');
      if (input) input.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      modal.hidden = true;
      if (backdrop) backdrop.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeModal();
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeModal();
      } else {
        openModal();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
  }

  function init() {
    initPredictiveSearchInputs();
    initSearchModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
